/**
 * Dispatch takes an existing state and performs the result of a transaction
 * on top of it. This is different than other Flux implementations.
 *
 * Dispatch answers the question:
 * "What will change when I account for a transaction?"
 */

'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _send = require('./send');

var _send2 = _interopRequireDefault(_send);

var _update = require('./update');

var dispatch = function dispatch(stores, state, _ref) {
  var active = _ref.active;
  var payload = _ref.payload;
  var type = _ref.type;

  for (var i = 0, len = stores.length; active && i < len; i++) {
    var _stores$i = stores[i];
    var key = _stores$i[0];
    var store = _stores$i[1];

    var answer = _send2['default'](key, store, state, type, payload);

    if (answer !== undefined) {
      state = _update.set(state, key, answer);
    }
  }

  return state;
};

exports['default'] = dispatch;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9kaXNwYXRjaC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7OztvQkFRaUIsUUFBUTs7OztzQkFDTCxVQUFVOztBQUU5QixJQUFJLFFBQVEsR0FBRyxTQUFYLFFBQVEsQ0FBYSxNQUFNLEVBQUUsS0FBSyxFQUFFLElBQXlCLEVBQUU7TUFBekIsTUFBTSxHQUFSLElBQXlCLENBQXZCLE1BQU07TUFBRSxPQUFPLEdBQWpCLElBQXlCLENBQWYsT0FBTztNQUFFLElBQUksR0FBdkIsSUFBeUIsQ0FBTixJQUFJOztBQUM3RCxPQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxHQUFHLEdBQUcsTUFBTSxDQUFDLE1BQU0sRUFBRSxNQUFNLElBQUksQ0FBQyxHQUFHLEdBQUcsRUFBRSxDQUFDLEVBQUUsRUFBRTtvQkFDdEMsTUFBTSxDQUFDLENBQUMsQ0FBQztRQUF4QixHQUFHO1FBQUUsS0FBSzs7QUFFaEIsUUFBSSxNQUFNLEdBQUcsa0JBQUssR0FBRyxFQUFFLEtBQUssRUFBRSxLQUFLLEVBQUUsSUFBSSxFQUFFLE9BQU8sQ0FBQyxDQUFBOztBQUVuRCxRQUFJLE1BQU0sS0FBSyxTQUFTLEVBQUU7QUFDeEIsV0FBSyxHQUFHLFlBQUksS0FBSyxFQUFFLEdBQUcsRUFBRSxNQUFNLENBQUMsQ0FBQTtLQUNoQztHQUNGOztBQUVELFNBQU8sS0FBSyxDQUFBO0NBQ2IsQ0FBQTs7cUJBRWMsUUFBUSIsImZpbGUiOiJzcmMvZGlzcGF0Y2guanMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIERpc3BhdGNoIHRha2VzIGFuIGV4aXN0aW5nIHN0YXRlIGFuZCBwZXJmb3JtcyB0aGUgcmVzdWx0IG9mIGEgdHJhbnNhY3Rpb25cbiAqIG9uIHRvcCBvZiBpdC4gVGhpcyBpcyBkaWZmZXJlbnQgdGhhbiBvdGhlciBGbHV4IGltcGxlbWVudGF0aW9ucy5cbiAqXG4gKiBEaXNwYXRjaCBhbnN3ZXJzIHRoZSBxdWVzdGlvbjpcbiAqIFwiV2hhdCB3aWxsIGNoYW5nZSB3aGVuIEkgYWNjb3VudCBmb3IgYSB0cmFuc2FjdGlvbj9cIlxuICovXG5cbmltcG9ydCBzZW5kIGZyb20gJy4vc2VuZCdcbmltcG9ydCB7IHNldCB9IGZyb20gJy4vdXBkYXRlJ1xuXG5sZXQgZGlzcGF0Y2ggPSBmdW5jdGlvbiAoc3RvcmVzLCBzdGF0ZSwgeyBhY3RpdmUsIHBheWxvYWQsIHR5cGUgfSkge1xuICBmb3IgKHZhciBpID0gMCwgbGVuID0gc3RvcmVzLmxlbmd0aDsgYWN0aXZlICYmIGkgPCBsZW47IGkrKykge1xuICAgIHZhciBbIGtleSwgc3RvcmUgXSA9IHN0b3Jlc1tpXVxuXG4gICAgdmFyIGFuc3dlciA9IHNlbmQoa2V5LCBzdG9yZSwgc3RhdGUsIHR5cGUsIHBheWxvYWQpXG5cbiAgICBpZiAoYW5zd2VyICE9PSB1bmRlZmluZWQpIHtcbiAgICAgIHN0YXRlID0gc2V0KHN0YXRlLCBrZXksIGFuc3dlcilcbiAgICB9XG4gIH1cblxuICByZXR1cm4gc3RhdGVcbn1cblxuZXhwb3J0IGRlZmF1bHQgZGlzcGF0Y2hcbiJdfQ==




/*****************
 ** WEBPACK FOOTER
 ** ./~/microcosm/dispatch.js
 ** module id = 196
 ** module chunks = 0
 **/